import { ApplicationType } from '@/types/user';

import ComingSoonPage from './ComingSoonPage';

export default function RightStartComingSoonPage() {
  return <ComingSoonPage type={ApplicationType.JOINT} />;
}
